var React = require('react');

function IconHorizontalChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0zM208 480c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0zM384 112l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48z"}));
}

IconHorizontalChart.defaultProps = {"viewBox":"0 0 448 512","fill":"currentColor"};

module.exports = IconHorizontalChart;

IconHorizontalChart.default = IconHorizontalChart;
